module.exports = __webpack_public_path__ + "static/media/Mobile-Banner-Client-Scheduler.6ee65563.jpg";